import { getTourState, type GetTourState } from './get-tour-state';
import { setTourState, type SetTourState } from './set-tour-state';

export const actions = {
	getTourState,
	setTourState,
} as const;

export type StoreActions = typeof actions;

export type Actions = {
	getTourState: GetTourState;
	setTourState: SetTourState;
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { SetTourState };
